import React, { useState } from 'react';
import { map } from 'lodash';
import { useSelector } from 'react-redux';
import { WholeState } from '../../../store/common/type';
import { DownOutlined } from '@ant-design/icons';
import contentResource from '../../../locales/th/content.json';
import {
  Icon,
  FAQTitle,
  FAQWrapper,
  FAQItem,
  FAQHeading,
  FAQContainer,
  FAQContent,
} from './Faq.style';
import { sanitize } from '../../../common/helpers/utility/sanitizer';
interface FaqItemType {
  question: string;
  answer: string;
  _id: string;
}

interface FaqProps {
  faqData: FaqItemType[];
}

const Faq: React.FC<FaqProps> = ({ faqData = [] }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const FAQTitleText = contentResource.FAQTitle;
  const deviceType = useSelector((state: WholeState) =>
    state.common !== undefined ? state.common.deviceType : 'desktop',
  );

  const toggle = (index: number) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <FAQContainer deviceType={deviceType} data-test="faq-container">
      <FAQTitle data-test="faq-title">{FAQTitleText}</FAQTitle>
      <FAQWrapper>
        {map(faqData, (item, index) => {
          const isActive = activeIndex === index;

          return (
            <FAQItem key={item._id}>
              <FAQHeading
                onClick={() => toggle(index)}
                aria-expanded={isActive}
                aria-controls={`faq-content-${index}`}
                id={`faq-heading-${index}`}
              >
                {item.question}
                <Icon isActive={isActive}>
                  <DownOutlined />
                </Icon>
              </FAQHeading>

              {isActive && (
                <FAQContent
                  id={`faq-content-${index}`}
                  aria-labelledby={`faq-heading-${index}`}
                  dangerouslySetInnerHTML={{ __html: sanitize(item.answer) }}
                />
              )}
            </FAQItem>
          );
        })}
      </FAQWrapper>
    </FAQContainer>
  );
};

export default Faq;
